<script lang="ts" setup>
/**
 * リプライ総数。
 */

import { defineProps, defineEmits } from "vue";

interface Props {
	/**
	 * 「他返信時表示」文言
	 */
	replyMoreDisplayText: string;
	/**
	 * リプライ総件数。
	 */
	replyCount: number;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
const props = defineProps<Props>();

interface Emits {
	(e: "on-click-more-button"): void;
}
const emit = defineEmits<Emits>();
const onclick = (): void => {
	emit("on-click-more-button");
};

/**
 * 表示文言。
 */
let displayText = props.replyMoreDisplayText.replace("${count}", props.replyCount.toString());

/**
 * 他返信があるかどうか。
 */
const isExistOtherReply = (): boolean => {
	return props.replyCount !== 0;
};
</script>

<template>
	<p @click="onclick" :disabled="isProcessingGetMoreReply" v-if="isExistOtherReply()" class="revico-community-talk-reply-details--reply-count">
		<font-awesome-icon icon="fa-solid fa-angle-right" />
		{{ displayText }}
	</p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	&-reply-details--reply-count {
		margin-top: 16px;
		cursor: pointer;
	}
}
</style>
